/* eslint-disable react/display-name */
import { useState, useContext, useEffect } from "react";
import { Paper, Grid } from "@mui/material";
import QRCode from "react-qr-code";

import { NexcalEmployeeLogo, PhcsLogo, BOPPanhandleFirstBankLogo } from "../../../../../assets";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MEMBER_ENV } from "../../../../../config/config";

import "./dentalCardStyles.css";
import BOPAlertCaution from "../BOPAlertCaution/BOPAlertCaution";

interface IDentalCardPanhandleProps {
	hasDentalPlan: boolean;
}
/* eslint-disable react/prop-types */
const DentalCardPanhandle: React.FC<IDentalCardPanhandleProps> = ({ hasDentalPlan }) => {
	const [localIP, setLocalIP] = useState("");
	const [urlLink, setUrlLink] = useState("");
	const { member } = useContext(AuthContext);

	// console.log("Member Details", member);
	const _ssn = maskSSN(member?.SSN);

	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		getLocalIPV4().then((ip) => setLocalIP(ip));
	}, []);

	useEffect(() => {
		const { group_number, date_of_birth, SSN } = member;

		// const localRedirectionLink1 = `http://192.168.1.35:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
		// 	SSN
		// )}&&db=${encryption(date_of_birth)}`;
		// setUrlLink(localRedirectionLink1);
		if (member) {
			// const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
			// 	SSN
			// )}&&db=${encryption(date_of_birth)}`;

			const prodRedirectionLink = "www.nexcaliber.com/eligibility-check";

			if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}
		if (member && localIP) {
			const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
		}
	}, [member, localIP]);

	if (!member) {
		return <div>Loading member details...</div>; // Display a loading state if `member` is null or undefined
	}

	// const _ssn = maskSSN(member?.SSN);
	return (
		<div>
			<div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
				{!hasDentalPlan && <BOPAlertCaution planName="Dental Plan" />}
			</div>
			<div
				className="employee-id-card-frontside-container card-content"
				style={{
					filter: hasDentalPlan ? "none" : "blur(5px)",
					pointerEvents: hasDentalPlan ? "auto" : "none"
				}}
			>
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<div style={{ textAlign: "center", position: "relative" }}>
							<h3 style={{ marginBottom: 0, fontSize: "15px" }}>Panhandle First Bank</h3>
							<h4 style={{ textDecoration: "underline", marginTop: 0, fontSize: "12px" }}>DENTAL PLAN</h4>
							<p style={{ marginTop: -18, fontSize: "10px" }}>Administered by Nexcaliber</p>
							<div>
								<QRCode
									size={256}
									style={{
										position: "absolute",
										right: "5px",
										top: "50%",
										transform: "translateY(-50%)",
										width: "4rem",
										height: "auto"
									}}
									value={urlLink}
									fgColor="#4e4e4e"
									bgColor="#ffffff"
								/>
								<div
									className="corner-border top-left"
									style={{
										position: "absolute",
										top: "-14px",
										left: "327px",
										width: "10px",
										height: "10px",
										borderTop: "2px solid #9c27b0",
										borderLeft: "2px solid #9c27b0"
									}}
								></div>
								<div
									className="corner-border top-right"
									style={{
										position: "absolute",
										top: -14,
										right: 0,
										width: "11px",
										height: "11px",
										borderTop: "2px solid #9c27b0",
										borderRight: "2px solid #9c27b0"
									}}
								></div>
								<div
									className="corner-border bottom-left"
									style={{
										position: "absolute",
										bottom: -14,
										left: 327,
										width: "11px",
										height: "11px",
										borderBottom: "2px solid #9c27b0",
										borderLeft: "2px solid #9c27b0"
									}}
								></div>

								{/* Bottom-right corner border */}
								<div
									className="corner-border bottom-right"
									style={{
										position: "absolute",
										bottom: -14,
										right: 0,
										width: "11px",
										height: "11px",
										borderBottom: "2px solid #9c27b0",
										borderRight: "2px solid #9c27b0"
									}}
								></div>
								<span
									style={{
										display: "block",
										fontSize: "9px",
										color: "black",
										textAlign: "right",
										position: "absolute",
										right: "0px",
										top: "calc(50% + 3rem)",
										transform: "translateY(-50%)"
									}}
								>
									Scan for Eligibility <br />
									<span style={{ marginRight: "8px" }}>and benefits</span>
								</span>
							</div>
						</div>

						<Grid container className="employee-middle-section-container">
							<div className="employee-detail" style={{ fontSize: "11px" }}>
								Employee ID Number : XXXX-XX-{maskSSN(member.SSN)}
							</div>
							<span style={{ fontSize: "9px" }}>
								This card is for identification only; it does not guarantee benefit payment
							</span>
							<div className="employee-detail" style={{ fontSize: "11px", marginTop: -4 }}>
								Employee Name : {member.last_name}, {member.first_name}
							</div>
						</Grid>
						<div className="border-seperator" />
						<Grid container className="employee-card-front-footer">
							<div>
								<h1
									style={{
										fontSize: "13px",
										margin: "0",
										textDecoration: "underline",
										textAlign: "center"
									}}
								>
									Dental Plan Benefits
								</h1>
								<div style={{}}>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Provider Network:
									</strong>
									<span style={{ marginLeft: 30 }}>No network any dental provider can be used</span>
								</div>
								<div>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Deductible per Person:
									</strong>
									<span style={{ marginLeft: 30 }}>$50</span>
								</div>
								<div>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Annual Maximum Benefit Per Person:
									</strong>
									<span style={{ marginLeft: 30 }}>$1,500</span>
								</div>
								<div>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Preventive / Diagnostic Services:
									</strong>
									<span style={{ marginLeft: 30 }}>100%</span>
								</div>
								<div>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Basic Services:
									</strong>
									<span style={{ marginLeft: 30 }}>80%</span>
								</div>
								<div>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Major Services:
									</strong>
									<span style={{ marginLeft: 30 }}>50%</span>
								</div>
								<div>
									<strong style={{ fontSize: "12px", fontWeight: "900", color: "black" }}>
										Orthodontic Services (child only):
									</strong>
									<span style={{ marginLeft: 30 }}>50%</span>
									<span
										style={{ display: "block", fontSize: "12px", color: "gray", marginLeft: 200 }}
									>
										Lifetime Maximum Per Child $1,500
									</span>
								</div>
							</div>
						</Grid>
					</Paper>
				</div>
			</div>
			<div
				className="employee-id-card-backside-container card-content"
				style={{
					filter: hasDentalPlan ? "none" : "blur(5px)",
					pointerEvents: hasDentalPlan ? "auto" : "none" // Prevent interaction with blurred content
				}}
			>
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<div className="card-back-topPortion-container">
							<span style={{ fontWeight: "900", fontSize: "15px", marginBottom: 12, color: "black" }}>
								For online claim access
							</span>
							<span style={{ fontWeight: 900 }}>
								Webpage address is https://member.enrollment.nexcaliber.com
							</span>
						</div>

						<div className="footer-border" />

						<div className="card-back-midPortion-container" style={{ marginTop: 10 }}>
							<div className="upper-section">
								<span style={{ fontWeight: "900", fontSize: "13px", marginBottom: 12, color: "black" }}>
									Dental / Enrollment Questions and Verification
								</span>
								<br />
								<span style={{ fontWeight: "bold", marginTop: "20px" }}>
									Nexcaliber: (800) 741-0185
								</span>
							</div>
							<div className="footer-border" />

							{/* <div className="footer-top-content-container" style={{ padding: "0.2rem" }}>
								<span
									className="footer-top-sub-content"
									style={{ marginLeft: "4px", fontSize: "0.65rem" }}
								>
									For Assistance locating a PRO provider, call Nexcaliber: (800) 741-0185
								</span>
							</div> */}
						</div>

						{/* <div className="footer-border" /> */}

						<div className="summary-benefits-footer-container" style={{ marginTop: 15 }}>
							<div className="footer-bottom-content" style={{ marginTop: "0.3rem" }}>
								Mail all claims to Nexcaliber
								<br />
								<span>PO Box 802422, Dallas, Texas 75380</span>
							</div>
							<div className="footer-logo-container">
								<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
							</div>

							{/* <div className="footer-content" style={{ marginLeft: "-0.2rem" }}>
								Medical and Dental Benefit / Enrollment Questions and Verifications : Call Nexcaliber
								(800) 741-0185
							</div> */}
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
};

export default DentalCardPanhandle;
